import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/components/Common/Button/index.js